import { StringColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	upiId: 'upiId',
	vpaName: 'vpaName'
};

export const columnConfigs = [
	StringColumn({
		title: 'UPI id',
		mapDataToValue: (data: any) => data[COL_NAMES.upiId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Vpa name',
		mapDataToValue: (data: any) => data[COL_NAMES.vpaName] || EMPTY_STRING
	})
];
